import { render } from "./InvestmentDetails.vue?vue&type=template&id=670b8282"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js"

import "./InvestmentDetails.vue?vue&type=style&index=0&id=670b8282&lang=css"
script.render = render

export default script